"use client";

import type {
  AllianceCards,
  BackgroundCard,
  BannerCarousel,
  BannerCta,
  CommonInfo,
  FAQ,
  FlightWidgets,
  HomeImageTextHeader,
  HomeSection,
  SubscribeCard,
} from "@repo/ui/types";

export type NormalizedHomePageSections = {
  commonInfo: CommonInfo;
  widgets: FlightWidgets;
  faqs: FAQ;
  subscribeCard: SubscribeCard;
  bannerCta: BannerCta;
  bannerCarousel: BannerCarousel;
  defaultDeparture: string;
  defaultDestination: string;
  showFareCache: boolean;
  defaultNoOfMonths: number;
  noOfMonthsIfNoFareCache: number;
  defaultPromoCode: string;
  backgroundImageCards: BackgroundCard;
  allianceCards: AllianceCards;
  imageTextHeader: HomeImageTextHeader;
};

export default function normalizeHomePageSections(
  sections: HomeSection,
): NormalizedHomePageSections {
  return Object.assign({}, ...sections);
}
